import TopicOne from "../commodities-market-contents/TopicOne";

const CommoditiesMarketContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__market">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>Competitive Spreads & High Liquidity</h3>
                <p>
                  Trade gold, oil, and silver with institutional-grade pricing
                  and instant order execution.
                </p>
                <h3>Flexible Leverage Options</h3>
                <p>
                  Optimize your risk exposure with leverage up to 1:1000 across
                  major commodities.
                </p>
                <h3>Seamless Multi-Asset Access</h3>
                <p>
                  Diversify effortlessly, trade commodities alongside Forex,
                  Crypto, and Indices from one platform.
                </p>
                <h3>Real-Time Analytics & Insights</h3>
                <p>
                  Stay ahead of market movements with live data, charts, and
                  price alerts integrated into MetaTrader 5.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/commodities_cfd/commodities_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommoditiesMarketContentOne;
